type Props = {
  t: (id: string, obj?: Object) => string,
  fileName?: string,
  isActive?: boolean,
};

export default ({ t, fileName, isActive }: Props) => {
  return {
    appeal: {
      isActive: {
        "ui:widget": "toggle",
        "ui:options": {
          labels: [
            { label: t("ACTIVE"), value: true },
            { label: t("INACTIVE"), value: false },
          ],
        },
      },
      kpiDays: {
        "ui:widget": isActive ? "number-input" : "hidden",
      },
      instruction: {
        "ui:widget": isActive ? "textarea" : "hidden",
      },
      appealForm: {
        "ui:widget": isActive ? "file-input" : "hidden",
        "ui:options": {
          accept: [
            "application/pdf",
            "application/zip",
            "text/csv",
            "text/plain",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-powerpoint",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
          ].join(","),
          fileName,
        },
      },
    },
    reasons: {
      name: {
        "ui:widget": "text",
        "ui:options": {
          required: true,
          editable: true,
          minWidth: "85%",
        },
      },
      isActive: {
        "ui:widget": "switch",
        "ui:options": {
          editable: true,
        },
      },
    },
    outcome: {
      name: {
        "ui:widget": "text",
        "ui:options": {
          required: true,
          editable: true,
          minWidth: "85%",
        },
      },
      isActive: {
        "ui:widget": "switch",
        "ui:options": {
          editable: true,
        },
      },
    },
  };
};
